module.exports = __webpack_public_path__ + "img/22logo(Black)@2x.d24f57d0.png";